import { useLoading, useRootAppStore } from "@hooks";
import { useNotification } from "@utils/notifications";
import { useTranslation } from "react-i18next";
import { contactService } from "@services/info/contact";
import { setTabTitle } from "@utils";

export function useContact(reset: (state?: { [key: string]: any }) => void) {
	const { setIsLoading } = useLoading();
	const { showSuccess, showError } = useNotification();
	const { user, secondaryUser } = useRootAppStore().userAuthStore;

	const { t } = useTranslation();

	const onSuccess = async (
		data: Omit<
			Parameters<(typeof contactService)["sendInquiry"]>,
			"challengeResponse"
		>
	) => {
		try {
			setIsLoading(true);

			await contactService.sendInquiry({
				...data,
			});
			reset();
			showSuccess("specific:INFO_PAGES.CONTACT.CONTACT_US_SUCCESS");
		} catch (error) {
			showError("specific:INFO_PAGES.CONTACT.CONTACT_US_ERROR");
		} finally {
			setIsLoading(false);
		}
	};

	const onInitialize = () => {
		setTabTitle(t("specific:INFO_PAGES.NAVIGATION.CONTACT"));
		const internetUserAccount = [user, secondaryUser].find(
			(acc) => acc?.isInternetUser
		);
		if (internetUserAccount != null) {
			reset({
				userName: user?.username,
				email: internetUserAccount.email,
			});
		} else if (user != undefined) {
			reset({ userName: user?.username, email: user?.email });
		}

		window.scrollTo(0, 0);
	};
	return { onSuccess, onInitialize };
}
